
import { Component } from "vue-property-decorator";
import BaseSectionDynamicComponent from "../form-component-section.base";
import { ComponentTypeDictionaryService } from "@/app/dynamic-components/forms/form-components/form-component.lookup";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

type TestSectionMetaData = {
  test?: string;
};

@Component({
  components: {DynamicComponentConfigManager},
  computed: {
    ComponentTypeDictionaryService() {
      return ComponentTypeDictionaryService;
    },
  },
})
export default class TestSection extends BaseSectionDynamicComponent<TestSectionMetaData> {}
